"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKLayoutShellContext = void 0;
var react_1 = __importDefault(require("react"));
/**
 * GKLayoutShell context.
 * Currently only handles nav expansion states.
 * Should be used via GKLayoutShellManager whenever possible.
 */
exports.GKLayoutShellContext = react_1.default.createContext({
    setNavExpanded: function () { return null; },
});
